import { render, staticRenderFns } from "./sponPopup.vue?vue&type=template&id=e2a4138a"
import script from "./sponPopup.vue?vue&type=script&lang=js"
export * from "./sponPopup.vue?vue&type=script&lang=js"
import style0 from "./sponPopup.vue?vue&type=style&index=0&id=e2a4138a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports